function LabInfoClear(
  setFieldValue: Function,
  setFieldTouched: Function
) {
  let fields: any = {
    "laboratoryInfo.labortaryId": "",
    "laboratoryInfo.labortaryName": "",
    "laboratoryInfo.labortaryPhone": "",
    "laboratoryInfo.labortaryFax": "",
  };

  Object.keys(fields).map((field) => {
    setFieldValue(field, fields[field], true);
    setFieldTouched(field, true, true);
  });
}
export default LabInfoClear;
